<template>
  <div class="gw1041-container">
    <div class="sensor-view">
      <gwSensorView :sensorList="sensorList" :realDataObj="realDataObj" />
    </div>

    <div class="map-view">
      <bmapView style="height: 500px" :res="realDataObj" />
    </div>
  </div>
</template>

<script>
import gwSensorView from '@/components/gwSensor/index.vue';
import bmapView from '../GW1021/components/BMapGL/index.vue';
import { toBmapPos2 } from '@/utils/bmapUtil';
import { gwDeviceDataList } from '@/api/firefighting';
import { isEmpty } from '@/utils/is';
import ctt from '@/utils/const/index';

export default {
  name: 'GW1041-device',
  components: {
    gwSensorView,
    bmapView
  },
  computed: {
    sn() {
      return this.$attrs.sn || this.$route.params.sn;
    }
  },
  sockets: {
    '/socket/detect/detail'(data) {
      if (data.sn !== this.sn) return;
      if (isEmpty(data)) return;
      let positionArr = toBmapPos2({ coordinate: [data.longitude, data.latitude] });

      Object.assign(this.realDataObj, data);
      this.realDataObj.longitude = positionArr[0];
      this.realDataObj.latitude = positionArr[1];
    }
  },
  data() {
    return {
      disableNotice: true,
      sensorList: [
        {
          name: '伽马剂量率',
          prop: 'gammaValue',
          unitName: 'nSv/h'
        },
        {
          name: '核素1',
          prop: 'isotope1'
        },
        {
          name: '核素2',
          prop: 'isotope2'
        },
        {
          name: '核素3',
          prop: 'isotope3'
        },
        {
          name: '检测时间',
          prop: 'testTime'
        }
      ],
      realDataObj: {
        testTime: '',
        gammaValue: '',
        isotope1: '',
        isotope2: '',
        isotope3: '',
        longitude: 0,
        latitude: 0
      }
    };
  },
  mounted() {
    this.loadDeviceDataFunc();
  },

  methods: {
    loadDeviceDataFunc() {
      gwDeviceDataList({ deviceTypeCode: [ctt.GW1041], sn: this.sn }).then(res => {
        const { data } = res;
        let positionArr = toBmapPos2({ coordinate: [data.longitude, data.latitude] });

        Object.assign(this.realDataObj, data);
        this.realDataObj.longitude = positionArr[0];
        this.realDataObj.latitude = positionArr[1];
      });
    }
  }
};
</script>

<style lang="scss">
.gw1041-container {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  gap: 20px;
  .map-view,
  .sensor-view {
    width: 50%;
  }

  .sensor-view {
    .el-row {
      margin-bottom: 10px;
      .grid-content {
        height: 150px;
        border: 1px solid rgb(96, 118, 173);
        margin-bottom: 20px;
        .sensor-info {
          //   text-align: center;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          .name,
          .unit {
            font-size: 18px;
          }
          .value {
            color: #00e401;
            font-size: 22px;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
